import * as React from 'react';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { IconSizes } from '@components/atoms/Icon/icon-prop-types';

export const WrestlingColored = ({ size = 'xsmall' }: IconProps) => {
    return (
        <svg
            width={IconSizes[size]}
            height={IconSizes[size]}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            className="icon-freeform"
        >
            <g id="Wrestling" fill="none" fillRule="evenodd">
                <path d="M0 0h24v24H0z" />
                <path
                    d="m18.537 17.808 1.891-.39c1.354-.235 1.572-.84 1.572-2.177v-2.245c0-1.775-.373-3.266-2.187-3.462l-1.276-.137v8.41zM12 22.006c-2.124 0-2.957-.96-2.957-.96s.845-1.247 2.957-1.247 2.648 1.104 2.648 1.104-.524 1.103-2.648 1.103zM5.463 18.354l-1.426-.396c-.91-.234-1.574-1.38-1.574-2.717v-2.245c0-1.775.923-3.266 2.143-3.462l.857-.137v8.957z"
                    fill="#FF4054"
                />
                <path
                    d="M21 14.947c0 .73-.546 1.354-1.312 1.487l-.746.139v-5.825l.054.005c1.143.123 2.004 1.048 2.004 2.153v2.041zm-5.673 4.398c-.649-.533-1.804-1.254-3.327-1.254-1.524 0-2.678.721-3.327 1.254a3.504 3.504 0 0 1-1.615-1.79v-7.258c.835-.319 2.593-.862 4.942-.862 2.35 0 4.108.544 4.942.862v7.258a3.5 3.5 0 0 1-1.615 1.79zM12 21a3.1 3.1 0 0 1-1.573-.453c.407-.241.946-.456 1.573-.456s1.166.215 1.573.456A3.106 3.106 0 0 1 12 21zm-6.942-4.427-.76-.142C3.546 16.301 3 15.677 3 14.947v-2.041c0-1.105.861-2.03 2.005-2.153l.053-.005v5.825zM7.141 4.766C8.224 3.594 9.858 3 12 3c2.135 0 3.767.591 4.849 1.755 1.161 1.249 1.475 2.918 1.554 3.923l-.188-.02c-.637-.292-2.929-1.223-6.215-1.223s-5.579.931-6.215 1.223l-.193.021c.076-.999.385-2.654 1.549-3.913zm13.287 4.33c-.022-1.162-.292-3.73-2.1-5.687C16.852 1.811 14.723 1 12 1c-2.723 0-4.852.811-6.328 2.409-1.808 1.958-2.078 4.526-2.101 5.688C2.05 9.74 1 11.204 1 12.906v2.041c0 1.707 1.244 3.16 2.944 3.453l1.447.269c.595 1.204 1.544 2.108 2.845 2.682C8.663 21.791 10.014 23 12 23c1.986 0 3.337-1.21 3.764-1.649 1.301-.574 2.25-1.478 2.846-2.682l1.432-.267C21.756 18.106 23 16.653 23 14.947v-2.041c0-1.702-1.05-3.167-2.572-3.81z"
                    fill="#0D0E0F"
                />
            </g>
        </svg>
    );
};
